import { CONSUMER_MODE, CONSUMER_PARTIAL_MODE } from '../../utils/constants';
/**
 * Storage is async if mode is consumer or partial consumer
 */
export function isStorageSync(settings) {
    return [CONSUMER_MODE, CONSUMER_PARTIAL_MODE].indexOf(settings.mode) === -1 ? true : false;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-commons/esm/trackers/impressionObserver/utils.js
// module id = 1316
// module chunks = 25